export const group = state => state.group
export const groups = state => state.groups
